import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

const StudentBasicInfo = ({ student }) => (
  <div>
    <h5>Información básica</h5>
    <div className="multiple-fields">
      <div>
        <h6>Nombre</h6>
        <p>{student.firstName}</p>
      </div>
      <div>
        <h6>Apellido</h6>
        <p>{student.lastName}</p>
      </div>
    </div>
    <div className="multiple-fields">
      <div>
        <h6>Cédula</h6>
        <p>{student.ci}</p>
      </div>
      <div>
        <h6>Matrícula</h6>
        <p>{student.enrollment || '-'}</p>
      </div>
    </div>
    <div className="multiple-fields">
      <div>
        <h6>Fecha de nacimiento</h6>
        <p>{moment(student.birthdate).format('DD/MM/YYYY')}</p>
      </div>
      <div>
        <h6>Nacionalidad</h6>
        <p>{student.nationality}</p>
      </div>
    </div>
    <div className="multiple-fields">
      <div>
        <h6>Dirección</h6>
        <p>{student.address}</p>
      </div>
      <div>
        <h6>Barrio</h6>
        <p>{student.neighborhood}</p>
      </div>
    </div>
    <div className="multiple-fields">
      <div>
        <h6>Atención Médica</h6>
        <p>{student.medicalCare || '-'}</p>
      </div>
      <div>
        <h6>Emergencia Médica</h6>
        <p>{student.medicalEmergency || '-'}</p>
      </div>
    </div>
    <div className="multiple-fields">
      <div>
        <h6>Teléfono Hogar</h6>
        <p>{student.homePhone}</p>
      </div>
      <div>
        <h6>Composición del nucleo familiar</h6>
        <p>{_.capitalize(student.familyComposition)}</p>
      </div>
    </div>
  </div>
);

const { object } = PropTypes;

StudentBasicInfo.propTypes = {
  student: object.isRequired
};

export default StudentBasicInfo;



// WEBPACK FOOTER //
// ./src/components/student/StudentBasicInfo.js